import guidelinesApi from '@/api/guidelines.api'


const state = {

}


const getters = {

}


const actions = {
  async updateGuidelines ({ commit }, { chainId, guidelines }) {
    const response = await guidelinesApi.updateGuidelines(chainId, guidelines)
  }
}


const mutations = {

}


export default {
  state,
  getters,
  actions,
  mutations
}
